import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_secondary_navigation_bar = _resolveComponent("secondary-navigation-bar")
  const _component_base_title = _resolveComponent("base-title")
  const _component_return_to_element = _resolveComponent("return-to-element")
  const _component_base_view = _resolveComponent("base-view")

  return (_openBlock(), _createBlock(_component_base_view, null, {
    default: _withCtx(() => [
      _createVNode(_component_secondary_navigation_bar, {
        navigation: $options.navigation,
        "data-qa-prefix": "backer-center"
      }, null, 8 /* PROPS */, ["navigation"]),
      _createElementVNode("main", {
        class: _normalizeClass(['gfu-layout__main _pt-4 _pt-6--m js-main-content', $options.layoutClasses])
      }, [
        _createVNode(_component_base_title, { as: "h1" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($props.title), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }),
        _renderSlot(_ctx.$slots, "default")
      ], 2 /* CLASS */),
      _createVNode(_component_return_to_element, { "element-id": "js-main-header" })
    ]),
    _: 3 /* FORWARDED */
  }))
}